export const comma ={
    methods: {
        addComma(val, decimal){
            let covert_val = parseInt(val);
            if(decimal)
            {
                //소수점 원본 표기
                covert_val = val;
            }
            return covert_val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
}
